export default __webpack_public_path__ + "static/media/emailSecond.df681266.jpg";